export const BRAZILIAN_DATE_FORMAT = "DD/MM/YYYY";
export const BRAZILIAN_DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm";

export const withBrazilianDateDisplay = (config: Record<string, unknown> = {}) => ({
  ...config,
  dateFormat: BRAZILIAN_DATE_FORMAT,
  dateTimeFormat: BRAZILIAN_DATE_TIME_FORMAT,
});
